var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeolLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 710,
    height: 160,
    viewBox: "0 0 710 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3 27H150.9C158.1 27 163.9 21.2 163.9 14C163.9 6.8 158.1 1 150.9 1H46.3C21.3 1 1 21.3 1 46.3C1 71.3 21.3 91.6 46.3 91.6H117.2C128.6 91.6 137.9 100.9 137.9 112.3C137.9 123.7 128.6 133 117.2 133H14C6.8 133 1 138.8 1 146C1 153.2 6.8 159 14 159H117.1C142.9 159 163.8 138.1 163.8 112.3C163.8 86.5 142.9 65.6 117.1 65.6H46.3C35.7 65.6 27 57 27 46.3C27 35.6 35.6 27 46.3 27Z",
    fill: "#001635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.6 1H423.7C380.1 1 344.7 36.4 344.7 80C344.7 123.6 380.1 159 423.7 159H445.6C489.2 159 524.6 123.6 524.6 80C524.6 36.4 489.2 1 445.6 1ZM445.6 133H423.7C394.5 133 370.7 109.3 370.7 80C370.7 50.7 394.4 27 423.7 27H445.6C474.8 27 498.6 50.7 498.6 80C498.6 109.3 474.9 133 445.6 133Z",
    fill: "#001635"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M435.8 59.7H433.4C422.189 59.7 413.1 68.7886 413.1 80C413.1 91.2114 422.189 100.3 433.4 100.3H435.8C447.011 100.3 456.1 91.2114 456.1 80C456.1 68.7886 447.011 59.7 435.8 59.7Z",
    fill: "#001635"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.6 27H326.6C333.8 27 339.6 21.2 339.6 14C339.6 6.8 333.8 1 326.6 1H260.6C217 1 181.6 36.3 181.6 80C181.6 123.7 216.9 159 260.6 159H326.6C333.8 159 339.6 153.2 339.6 146C339.6 138.8 333.8 133 326.6 133H260.6C235.8 133 215 116 209.3 93H292.4C299.6 93 305.4 87.2 305.4 80C305.4 72.8 299.6 67 292.4 67H209.3C215.1 44 235.9 27 260.6 27Z",
    fill: "#001635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M696 133H577.1V14C577.1 6.8 571.3 1 564.1 1C556.9 1 551.1 6.8 551.1 14V145.9C551.1 153.1 556.9 158.9 564.1 158.9H696C703.2 158.9 709 153.1 709 145.9C709 138.7 703.2 132.9 696 132.9V133Z",
    fill: "#001635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeolLogoBlue);
export default __webpack_public_path__ + "static/media/seol-logo-blue.2d141713c5e78c54af712835888a2263.svg";
export { ForwardRef as ReactComponent };